import Main from './top/main';

const main = new Main();